// extracted by mini-css-extract-plugin
export var label = "_e6-2";
export var slideContainer = "_e6-0";
export var slider = "_e6-1";